// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"53037b1e","678":"10ccc36e"}[chunkId] + ".css";
};